import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { sortBy } from 'lodash';

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

const null_measure = {
  measure: null,
  value: null,
  years: null,
};
function AddOperationalSavingsMeasureModal(props) {
  const {
    show,
    onHide,
    organizationId,
    projects,
    defaultProject,
    addToList,
    showToast,
  } = props;

  const [disabled, setDisabled] = useState(false);
  const [measureData, setMeasureData] = useState(null_measure);
  const [projectIds, setProjectIds] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setMeasureData(null_measure);
    if (defaultProject !== null) {
      setProjectIds([defaultProject.id]);
    } else {
      setProjectIds([]);
    }
  }, [show, defaultProject]);

  const parseNumber = (val) => {
    const float_val = !isNaN(parseFloat(val.replace(/,/g, '')))
      ? parseFloat(val.replace(/,/g, ''))
      : 0;
    return float_val;
  };

  useEffect(() => {
    setDisabled(
      measureData['measure'] === null ||
        measureData['value'] === null ||
        measureData['years'] === null
    );
  }, [measureData]);

  const updateSet = (values) => {
    let arr = Array.prototype.slice.call(values);
    arr = arr.map((item) => item.value);
    setProjectIds(arr);
  };

  const addMeasure = () => {
    setIsLoading(true);
    ApiServiceServerless.post(
      `/operational_savings/${organizationId}`,
      {
        org_id: organizationId,
        ...measureData,
        project_ids: projectIds,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        showToast('success', 'Success', 'Measure successfully added');
        addToList(res.data, 'performance_measures');
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton> Add a Measure</Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            {'Measure'}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <Form.Control
              required
              placeholder=''
              onChange={(e) =>
                setMeasureData({
                  ...measureData,
                  measure: e.target.value,
                })
              }
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            {'$/Year '}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <NumberFormat
              customInput={Form.Control}
              thousandSeparator
              isNumericString
              decimalScale={2}
              fixedDecimalScale
              placeholder={'0.00'}
              onChange={(e) =>
                setMeasureData({
                  ...measureData,
                  value: parseNumber(e.target.value),
                })
              }
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            {'Duration (Years) '}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <NumberFormat
              customInput={Form.Control}
              thousandSeparator
              isNumericString
              decimalScale={0}
              fixedDecimalScale
              placeholder={'0'}
              onChange={(e) =>
                setMeasureData({
                  ...measureData,
                  years: parseNumber(e.target.value),
                })
              }
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>Project(s)</Form.Label>
          <Form.Control
            as='select'
            multiple
            disabled={defaultProject !== null}
            defaultValue={defaultProject !== null ? [defaultProject.id] : []}
            onChange={(e) => updateSet(e.target.selectedOptions)}
          >
            {sortBy(Object.values(projects), ['name'])
              .filter((project) => project.project_type === 'performance')
              .map((item) => (
                <option key={`project-opt-${item.id}`} value={item.id}>
                  {item.name}
                </option>
              ))}
          </Form.Control>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <AddEntityActionButtons
          onCancel={onHide}
          onSubmit={addMeasure}
          submitDisabled={disabled}
          isSubmitting={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
}

AddOperationalSavingsMeasureModal.propTypes = {
  defaultProject: PropTypes.object,
};

AddOperationalSavingsMeasureModal.defaultProps = {
  defaultProject: null,
};

export default AddOperationalSavingsMeasureModal;
